export default {
  list: { lazy: () => import('./NetworkTariffGroup'), component: 'NetworkTariffGroupList' },
  show: { lazy: () => import('./NetworkTariffGroup'), component: 'NetworkTariffGroupShow' },
  edit: { lazy: () => import('./NetworkTariffGroup'), component: 'NetworkTariffGroupEdit' },
  options: {
    list: {
      title: 'Network Tariffs (Grouped)',
      subtitle: null,
      breadCrumb: 'Network Tariffs (Grouped)',
    },
    show: {
      title: 'Network Tariff',
      subtitle: null,
      breadCrumb: 'Network Tariff',
    },
    edit: {
      title: 'Edit Network Tariff (Group)',
      subtitle: null,
      breadCrumb: 'Edit Network Tariff',
    },
  },
}
